import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Label, Button } from "components/bootstrap";
import { RelativeTime, Icon } from "components/common";
import IndexSizeSummary from "components/indices/IndexSizeSummary";
const FormattedLabels = ({ index, name }) => {
  const { t } = useTranslation("indexsets");
  const labels = [];
  if (index.is_deflector) {
    labels.push(
      /* @__PURE__ */ React.createElement(Label, { key: `${name}-deflector-label`, bsStyle: "primary" }, t("index_summary.label_active_write_index"))
    );
  }
  if (index.is_closed) {
    labels.push(
      /* @__PURE__ */ React.createElement(Label, { key: `${name}-closed-label`, bsStyle: "warning" }, t("index_summary.label_closed"))
    );
  }
  if (index.is_reopened) {
    labels.push(
      /* @__PURE__ */ React.createElement(Label, { key: `${name}-reopened-label`, bsStyle: "success" }, t("index_summary.label_reopened"))
    );
  }
  return /* @__PURE__ */ React.createElement("span", { className: "index-label" }, labels);
};
const FormattedIndexRange = ({
  index,
  indexRange,
  isDeflector
}) => {
  const { t } = useTranslation("indexsets");
  if (isDeflector) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "index_summary.contains_up_to",
        components: { relativeTime: /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: /* @__PURE__ */ new Date() }) }
      }
    ));
  }
  const sizes = index.size;
  if (sizes) {
    const count = sizes.events;
    const { deleted } = sizes;
    if (count === 0 || count - deleted === 0) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, t("index_summary.empty"));
    }
  }
  if (!indexRange) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, t("index_summary.range_unknown"));
  }
  if (indexRange.begin === 0) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "index_summary.contains_up_to",
        components: { relativeTime: /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: indexRange.end }) }
      }
    ));
  }
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "index_summary.contains_from",
      components: {
        begin: /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: indexRange.begin }),
        end: /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: indexRange.end })
      }
    }
  ));
};
const IndexSummary = ({ children, index, indexRange = void 0, isDeflector, name }) => {
  const { t } = useTranslation("indexsets");
  const [showDetails, setShowDetails] = useState(isDeflector);
  const toggleShowDetails = (event) => {
    event.preventDefault();
    setShowDetails((prev) => !prev);
  };
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h2", null, name, " ", /* @__PURE__ */ React.createElement("small", null, /* @__PURE__ */ React.createElement(FormattedLabels, { index, name }), " ", /* @__PURE__ */ React.createElement(FormattedIndexRange, { index, indexRange, isDeflector }), " ", /* @__PURE__ */ React.createElement(IndexSizeSummary, { index }), /* @__PURE__ */ React.createElement(Button, { onClick: toggleShowDetails, bsStyle: "link" }, /* @__PURE__ */ React.createElement("span", { className: "index-more-actions" }, /* @__PURE__ */ React.createElement(Icon, { name: showDetails ? "arrow_drop_down" : "arrow_right" }), " ", showDetails ? t("index_summary.hide_details") : t("index_summary.show_details"))))), /* @__PURE__ */ React.createElement("div", { className: "index-info-holder" }, showDetails && children));
};
export default IndexSummary;
